import React, { useState } from 'react';
import styled from 'styled-components';
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedinIn } from 'react-icons/fa';

const ContactContainer = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 20px;
  margin-bottom: 60px; /* Add margin to prevent footer overlap */
`;

const PageHeader = styled.div`
  text-align: center;
  margin: 60px 0;
`;

const HeaderTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 20px;
`;

const HeaderDescription = styled.p`
  max-width: 600px;
  margin: 0 auto;
  color: #666;
  font-size: 1.1rem;
  line-height: 1.6;
`;

const ContactContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  
  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const FormSection = styled.div`
  flex: 1;
`;

const InfoSection = styled.div`
  flex: 1;
`;

const ContactForm = styled.form``;

const FormHeader = styled.h2`
  font-size: 1.8rem;
  margin-bottom: 20px;
`;

const FormRow = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  
  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const FormGroup = styled.div`
  flex: 1;
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  
  &:focus {
    outline: none;
    border-color: #291759;
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  
  &:focus {
    outline: none;
    border-color: #291759;
  }
`;

const Textarea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  min-height: 150px;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: #291759;
  }
`;

const SubmitButton = styled.button`
  background-color: #291759;
  color: white;
  border: none;
  padding: 14px 30px;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #1e0f45;
  }
`;

const InfoBox = styled.div`
  background-color: #f9f9ff;
  padding: 30px;
  border-radius: 8px;
`;

const InfoHeader = styled.h2`
  font-size: 1.8rem;
  margin-bottom: 25px;
`;

const OfficeInfo = styled.div`
  margin-bottom: 30px;
`;

const OfficeHeader = styled.h3`
  font-size: 1.3rem;
  margin-bottom: 10px;
`;

const AddressLine = styled.p`
  color: #666;
  margin-bottom: 5px;
  line-height: 1.6;
`;

const ContactHours = styled.div`
  margin-bottom: 25px;
`;

const ContactHoursHeader = styled.h3`
  font-size: 1.3rem;
  margin-bottom: 10px;
`;

const HoursLine = styled.p`
  color: #666;
  margin-bottom: 5px;
  line-height: 1.6;
`;

const ContactInfoSection = styled.div`
  margin-bottom: 30px;
`;

const ContactInfoHeader = styled.h3`
  font-size: 1.3rem;
  margin-bottom: 15px;
`;

const ContactInfoItem = styled.div`
  margin-bottom: 10px;
`;

const ContactLabel = styled.span`
  color: #666;
  margin-right: 10px;
`;

const ContactValue = styled.span`
  color: #291759;
  font-weight: 500;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 25px;
`;

const SocialIcon = styled.a`
  background-color: #291759;
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  
  &:hover {
    background-color: #1e0f45;
    transform: translateY(-3px);
  }
`;

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    topic: '',
    message: ''
  });
  
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Add form submission logic here
    alert('Message sent! We\'ll get back to you soon.');
  };
  
  return (
    <ContactContainer>
      <PageHeader>
        <HeaderTitle>Contact Us</HeaderTitle>
        <HeaderDescription>Have questions about Wonder? We're here to help you on your health journey.</HeaderDescription>
      </PageHeader>
      
      <ContactContent>
        <FormSection>
          <FormHeader>Get in Touch</FormHeader>
          
          <ContactForm onSubmit={handleSubmit}>
            <FormRow>
              <FormGroup>
                <Label htmlFor="firstName">First Name</Label>
                <Input 
                  type="text" 
                  id="firstName" 
                  name="firstName" 
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder="First Name"
                  required
                />
              </FormGroup>
              
              <FormGroup>
                <Label htmlFor="lastName">Last Name</Label>
                <Input 
                  type="text" 
                  id="lastName" 
                  name="lastName" 
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Last Name"
                  required
                />
              </FormGroup>
            </FormRow>
            
            <FormGroup>
              <Label htmlFor="email">Email</Label>
              <Input 
                type="email" 
                id="email" 
                name="email" 
                value={formData.email}
                onChange={handleChange}
                placeholder="your@email.com"
                required
              />
            </FormGroup>
            
            <FormGroup>
              <Label htmlFor="topic">Topic</Label>
              <Select 
                id="topic" 
                name="topic" 
                value={formData.topic}
                onChange={handleChange}
                required
              >
                <option value="">Select a topic</option>
                <option value="General Inquiry">General Inquiry</option>
                <option value="Support">Support</option>
                <option value="Partnership">Partnership</option>
                <option value="Nutrition Question">Nutrition Question</option>
              </Select>
            </FormGroup>
            
            <FormGroup>
              <Label htmlFor="message">Message</Label>
              <Textarea 
                id="message" 
                name="message" 
                value={formData.message}
                onChange={handleChange}
                placeholder="How can we help you?"
                required
              />
            </FormGroup>
            
            <SubmitButton type="submit">Send Message</SubmitButton>
          </ContactForm>
        </FormSection>
        
        <InfoSection>
          <InfoBox>
            <InfoHeader>Other Ways to Connect</InfoHeader>
            
            <OfficeInfo>
              <OfficeHeader>Visit Our Office</OfficeHeader>
              <AddressLine>123 Wonder Way, Suite 100</AddressLine>
              <AddressLine>San Francisco, CA 94104</AddressLine>
            </OfficeInfo>
            
            <ContactHours>
              <ContactHoursHeader>Hours</ContactHoursHeader>
              <HoursLine>Mon–Fri: 9am - 6pm PT</HoursLine>
              <HoursLine>Sat: 10am - 4pm PT</HoursLine>
            </ContactHours>
            
            <ContactInfoSection>
              <ContactInfoHeader>Contact Information</ContactInfoHeader>
              
              <ContactInfoItem>
                <ContactLabel>General Inquiries:</ContactLabel>
                <ContactValue>info@wonderhealth.com</ContactValue>
              </ContactInfoItem>
              
              <ContactInfoItem>
                <ContactLabel>Support:</ContactLabel>
                <ContactValue>support@wonderhealth.com</ContactValue>
              </ContactInfoItem>
              
              <ContactInfoItem>
                <ContactLabel>Phone:</ContactLabel>
                <ContactValue>(800) 123-4567</ContactValue>
              </ContactInfoItem>
            </ContactInfoSection>
            
            <ContactInfoHeader>Follow Us</ContactInfoHeader>
            <SocialLinks>
              <SocialIcon href="#" aria-label="Facebook">
                <FaFacebook />
              </SocialIcon>
              <SocialIcon href="#" aria-label="Instagram">
                <FaInstagram />
              </SocialIcon>
              <SocialIcon href="#" aria-label="Twitter">
                <FaTwitter />
              </SocialIcon>
              <SocialIcon href="#" aria-label="LinkedIn">
                <FaLinkedinIn />
              </SocialIcon>
            </SocialLinks>
          </InfoBox>
        </InfoSection>
      </ContactContent>
    </ContactContainer>
  );
};

export default Contact;